import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/core/services/base.service';
import { map } from 'rxjs/operators';

import { NotEmptyURLSearchParams } from 'src/app/shared/types/not-empty-url-search-params.type';

import { IDiscussionForm } from '../new/discussion.new.form';

@Injectable({
  providedIn: 'root'
})
export class DiscussionService {
  constructor(private base: BaseService) {}

  getDiscussionById(id) {
    return this.base
      .get('discussion/view/' + id)
      .pipe(map((res) => res.discussion));
  }

  // NOTE: discussions do not have paginations for posts
  // just a single one with a discussion's title as a content
  // and a set of comments attached to it
  getPostByDiscussionId(id) {
    const page = 1;
    const params = new NotEmptyURLSearchParams({
      page: page + ''
    });

    return this.base
      .get(`discussion/posts/${id}?${params}`)
      .pipe(map((res) => res.posts));
  }

  public saveArticle(data: IDiscussionForm, id = 0) {
    return this.base
      .post(`discussion/edit/${id}`, data)
      .pipe(map((res) => res.discussion));
  }
}
